import {i18n} from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {name: 'id', label: i18n('entities.employeeCategory.fields.id')},
  {name: 'label', label: i18n('entities.employeeCategory.fields.label')},
  {name: 'description', label: i18n('entities.employeeCategory.fields.description')},
  {
    name: 'createdAt',
    label: i18n('entities.employeeCategory.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.employeeCategory.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
